import Articles from "#sections/Articles";
import React from "react";

function ArticlesPage() {
  return <Articles />;
}
export default ArticlesPage;
